import { type BaseIntegrationConfigs, type BaseOauthIntegrationConfigs } from "./types";

export enum ContentSettingsEnum {
  FlowsOnly = 1,
  AllContent = 2,
}

export interface PackContentSettings {
  contentType: ContentSettingsEnum;
  packIds: number[];
}

export interface VivaIntegrationConfigs extends BaseIntegrationConfigs, BaseOauthIntegrationConfigs {
  isActive: boolean;
  tenantId?: string;
  packContentSettings: PackContentSettings;
}
